const { breakpoint, Breakpoint } = window.o_global ?? {};
export {
  Breakpoint,
  breakpoint
};
/*                                   */
